module.exports = __webpack_public_path__ + "2afcb7492b9c0eac4c814ba78652ec8a.pdf";